<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
      <div class="content-bottom-padded">
        <el-alert type="info" title="操作说明" show-icon >
          <div>
            <!--自动同步：开启自动同步后，总部添加编辑商品会自动同步上架到到店铺，保留开启前的商品状态。关闭同步后将保留已同步的商品数据-->
          </div>
        </el-alert>
      </div>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-select v-model="params.is_valid"  size="mini" @change="isValidSelectHandle" placeholder="是否启用" style="width: 100%;">
            <el-option
              v-for="(item, index) in isValidList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="2">
          <el-select v-model="params.is_third" size="mini" @change="plantSelectHandle" style="width: 100%;" >
            <el-option v-for="(item,index) in third_plant " :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="3">

          <el-cascader style="width: 100%;" placeholder="根据地区筛选"  :options="regions"  filterable  :props="{ checkStrictly: true }" @change="RegionChangeSearch"></el-cascader>

        </el-col> -->
        <el-col :span="3">
          <!--<el-select v-model="office_area_name"  placeholder="所属大区" @change="handleOfficeChange">-->
            <!--<el-option  v-for="item in office_area" :key="item.area_id" :label="item.name" :value="item.name" >-->
            <!--</el-option>-->
          <!--</el-select>-->

          <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                  :options="new_office_area"
                  :props="{ checkStrictly: true }"
                  v-model="selected_office_area_id"
                  size="mini"
                  clearable>
          </el-cascader>
        </el-col>
        <div v-show="false">
          <el-col ><el-input v-model="office_area_id" placeholder=""></el-input></el-col>
        </div>
        <el-col :span="3">
          <el-select v-model="params.shop_type_id" size="mini" @change="shopTypesSelectHandle" placeholder="选择店铺类型" style="width: 100%;">
            <el-option
            v-for="shop in shop_type_list_default"
            :key="shop.shop_type_id"
            :label="shop.shop_type_name"
            :value="shop.shop_type_id">
          </el-option>
            <el-option
              v-for="shop in shop_type_list"
              :key="shop.shop_type_id"
              :label="shop.shop_type_name"
              :value="shop.shop_type_id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input placeholder="店铺id" size="mini" v-model="params.distributor_id"></el-input>
        </el-col>
        <el-col :span="3">
          <el-input placeholder="店铺英克ID" size="mini" v-model="params.number"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="14">
          <el-input :rows="1" placeholder="店铺批量查询，多个英克ID之间使用回车符隔开" type='textarea' v-model="params.numbers" clearable size="mini">
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">

        <el-col :span="4">
          <el-input placeholder="店铺名称" size="mini" v-model="params.name"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="店铺地址" size="mini" v-model="params.address"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="固定电话" size="mini" v-model="params.telephone"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input placeholder="商家id" size="mini" v-model="params.merchant_id"></el-input>
        </el-col>
        <el-col v-if="system_mode === 'platform'" :span="3">
          <el-cascader
          size="mini"
            placeholder="选择标签"
            :options="tag.list"
            :props="{value:'tag_id', label: 'tag_name'}"
            v-model='select_tags_value'
            clearable
            @change="TagChangeAction">
          </el-cascader>
        </el-col>
        <el-col :span="3">
          <el-input size="mini" placeholder="联系人手机号" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-button-group>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="dialogOpen()" v-if="!is_distributor">添加店铺</el-button>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editCategoryAction"> 店铺商品分类 </el-button>
            <!-- <el-button type="primary" size="mini" v-if="system_mode === 'platform' && !is_distributor" icon="el-icon-edit" @click="addDistributorTag">打标签</el-button> -->
            <el-button type="primary" size="mini" v-if="!is_distributor" icon="el-icon-edit" @click="addDistributorTag">打标签</el-button>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="exportDistributorInfo">导出店铺基本信息</el-button>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="mulitClose">批量关闭</el-button>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="mulitOpen">批量开启</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table :data="list" @selection-change="handleSelectionChange" :height="wheight-140" v-loading="loading">
        <el-table-column type="selection" align="center" label="全选" ></el-table-column>
        <el-table-column prop="name" label="店铺名称"></el-table-column>
        <el-table-column prop="distributor_id" label="店铺ID">
          <template slot-scope="scope">
            {{scope.row.distributor_id}}
          </template>
        </el-table-column>
        <el-table-column prop="number" label="店铺英克ID">
          <template slot-scope="scope">
            {{scope.row.number}}
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="联系人"></el-table-column>
        <el-table-column prop="telephone" label="电话" ></el-table-column>
        <el-table-column prop="store_address" label="地址"></el-table-column>
        <!--
        <el-table-column label="自动同步">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.auto_sync_goods"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChangeAutoSyncGoods(scope.$index, scope.row)"></el-switch>
          </template>
        </el-table-column>
        -->
        <!-- <el-table-column label="审核商品">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_audit_goods"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChangeAuditGoods(scope.$index, scope.row)"></el-switch>
          </template>
        </el-table-column> -->
        <!--
        <el-table-column v-if="system_mode !== 'platform'" label="是否自提">
          <template slot-scope="scope">
            <el-switch v-if="!scope.row.lng && !scope.row.lat" disabled v-model="scope.row.is_ziti"  active-color="#13ce66"  inactive-color="#ff4949"></el-switch>
            <el-switch v-else v-model="scope.row.is_ziti"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChange(scope.$index, scope.row)"></el-switch>
          </template>
        </el-table-column>
        -->
        <el-table-column label="是否启用">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.is_valid == 'true'" >启用</el-tag>
            <el-tag type="info" v-else >禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="省医保">
          <template slot-scope="scope">
            <el-tag class="shengyibao_status" title="点击查询店铺省医保状态" type="success" v-if="scope.row.is_yibao == '1' && scope.row.yibao_code != ''" @click="getDistributorNetStatus(scope.row.distributor_id)">已开通</el-tag>
            <el-tag type="info" v-else >未开通</el-tag>
          </template>
        </el-table-column>
        <!--
        <el-table-column label="是否默认">
          <template slot-scope="scope">
            <el-switch  v-model="scope.row.is_default" :disabled="(scope.row.is_default || scope.row.is_valid != 'true') ? true : false"  @change="defaultSwitchChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        -->
        <!--
        <el-table-column label="是否发快递">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isExpress"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChangeExpress(scope.$index, scope.row)"></el-switch>
          </template>
        </el-table-column>
        -->
        <el-table-column v-if="system_mode === 'platform'" prop="tagList" label="标签">
          <template slot-scope="scope">
            <el-tag v-for="taglist in scope.row.tagList" :key="taglist.index" :color="taglist.tag_color" size="mini" :style="'color:'+ taglist.font_color" style="display: inline-block; margin-right:3px;">{{taglist.tag_name}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <router-link :to="{ path: matchHidePage('editor'), query: { distributor_id: scope.row.distributor_id}}">编辑</router-link>
            <router-link :to="{ path: matchInternalRoute('Storeshopitemanagement'), query: {distributor_id: scope.row.distributor_id}}">商品</router-link>
            <router-link :to="{ path: 'Shopcategorys', query: {distributor_id: scope.row.distributor_id}}">分类</router-link>
            <el-tag type="danger" size="mini">
               <router-link :to="{ path: 'distributor_template', query: {template_name:'yykweishop',distributor_name:scope.row.name,distributor_id: scope.row.distributor_id}}">模板编辑</router-link>
            </el-tag>
            <el-button type="text" size="mini" @click="tagUpdate(scope.row)" class="btn-gap">标签</el-button>
            <!-- 移除历史功能 -->
            <!-- <el-button type="text" size="mini" @click="CorrectionNPStore(scope.row)" class="btn-gap">校正NP库存</el-button> -->
            <!-- 移除历史功能 -->
            <!-- <el-button type="text" size="mini" @click="updateScope(scope.row)" class="btn-gap">更新电子围栏</el-button> -->
            <!-- <el-button v-if="system_mode === 'platform'" type="primary" plain round size="mini" @click="dialogShow(scope.row.distributor_id)">店铺装修</el-button> -->
            <!-- <el-button v-if="system_mode === 'platform'" type="primary" plain round size="mini" @click="dialogShow(scope.row.distributor_id,'pc')" style="margin-left:0px;margin-top:5px;">PC店铺装修</el-button> -->
            <router-link :to="{ path: matchHidePage('editor'), query: { copy_dis_id: scope.row.distributor_id}}">复制店铺</router-link>
          </template>
        </el-table-column>
        <el-table-column label="下载码" min-width="90">
          <template slot-scope="scope">
            <el-button type="text" @click="downDistributor(scope.row)">店铺码(微商城)</el-button>
            <!-- <router-link :to="{  path: matchInternalRoute('Storeshopitemanagement'), query: {distributor_id: scope.row.distributor_id}}">商品码</router-link> -->
            <!--router-link :to="{ path: matchHidePage('detail'), query: { distributor_id: scope.row.distributor_id, distributor_name: scope.row.name,parentPath: '/mall/marketing/distributor'}}">商品码</router-link-->
          </template>
        </el-table-column>
        <el-table-column label="APP二维码">
          <template slot-scope="scope">
            <el-button type="text" @click="showQR(scope.row)">点击下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-top-padded content-center">
        <el-pagination
          background
          layout="prev, pager, next, total, sizes"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10,20,50,100,200]"
          :total="total_count"
          :page-size="params.pageSize">
        </el-pagination>
      </div>
      <el-dialog title="下载店铺码" :visible.sync="downDistributorVal" :close-on-click-modal="false">
        <el-row>
          <el-col :span="8">
            <el-button type="text" @click="downDistributorCode(rowdata)">微商城小程序</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible" width="80%" title="编辑店铺首页" fullscreen lock-scroll>
        <shopDecoration :id="current" @saved="closeDialog" />
      </el-dialog>
      <el-dialog :visible.sync="pcDialogVisible" width="80%" title="编辑PC店铺首页" fullscreen lock-scroll>
        <pc-decoration v-if="pcDialogVisible" :id="current" @saved="closeDialog" usage="store"/>
      </el-dialog>

      <el-dialog title="为店铺打标签" class="right-dialog" :visible.sync="tag.dialog" :before-close="handleCancelLabelsDialog">
        <div class="tag-users view-flex view-flex-middle">
          <!-- <i class="iconfont icon-user-circle1"></i>
          <div class="view-flex-item">
            <span v-for="item in tag.editItem"> {{item}}，</span>
          </div> -->
        </div>
        <div class="selected-tags view-flex">
          <div class="label">已选中标签：</div>
          <div class="view-flex-item">
            <el-tag :key="index" v-for="(tag, index) in tag.currentTags" closable size="small" :disable-transitions="false" @close="tagRemove(index)">
              {{tag.tag_name}}
            </el-tag>
          </div>
        </div>
        <div>
          <el-tag class="tag-item" :key="index" v-for="(tag, index) in tag.tags" size="medium" color="#ffffff" :disable-transitions="false" @click.native="tagAdd(tag, index)">
            {{tag.tag_name}}
          </el-tag>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tag.dialog = false">取 消</el-button>
          <el-button type="primary" @click="submitItemTag">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加、编辑 店铺商品分类开始 -->
      <el-dialog :title="editTitleCategroy" :visible.sync="editCategroyVisible"  :before-close="handleCancel">

        <template>
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px">
            <div>
              <input type="checkbox" id="checkAll" @click="clickCheckAll()" v-model="checkAll"> 全选/反选
            </div>
            <div class="" v-if="categoryList_len >0">
              <div v-for='(item,index) in categoryList'>
                <input class="weui-check" type="checkbox" name="checkbox1"  @click='getDataId($event)' :data-id="item.category_id" v-model="item.isChecked"/>
                <span>{{ item.category_name }}</span>
              </div>
            </div>
          </el-form>
        </template>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editCategroyVisible = false">取消</el-button>
          <el-button type="primary" @click="submitCategoryAction" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
        </div>
      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { saveDistributor, exportDistributorInfo,saveIsExpress ,getDistributorList, getWxaDristributorCodeStream, setDefaultDistributor,editDistributorItemsCategory, getOfficeArea, getQRcode, updateScope, mulitOpenClose} from '../../../api/marketing'
  import {getCategory, correctionStore} from '@/api/goods'
  import { getTagList, distributorRelTags,getShopTypes} from '@/api/marketing'
  import district from '../../../common/district.json'

  import shopDecoration from '@/components/function/shopDecoration'
  import pcDecoration from '@/view/pc/homePage/default'
  import store from '@/store'
  import {createAccount, updateAccountInfo} from "../../../api/company"
  import Treeselect from '@riophae/vue-treeselect'
  import {getAreaManageList} from "../../../api/areamanage";
  import {getCouponQRcode} from "../../../api/cardticket";
  import {getShengyibaoNetStatus} from "../../../api/trade";

  // 取选中地区的值
  function getCascaderObj (val, opt) {
    return val.map(function (value, index, array) {
      for (var itm of opt) {
        if (itm.value === value) {
          opt = itm.children
          return itm
        }
      }
      return null
    })
  }

  export default {
    data () {
      return {
        editTitleCategroy: '',
        editCategroyVisible:false,
        CategoryList:[],
        office_area_name:[],
        selected_office_area_id:[],
        office_area_id:'',
        office_area_pid:'',
        loadingCategoryF: false,
        submitLoading:false,
        CategoryListparams:{
          page: 1,
          pageSize: 1000
        },
        is_distributor: false,
        dialogVisible: false,
        current: '', // 当前店铺id
        isValidList: [
          {name: '全部', value: ''},
          {name: '启用', value: 'true'},
          {name: '禁用', value: 'false'}
        ],
        third_plant:[
            {name:'全部店铺',value:''},
            {name:'怡康自营',value:'false'},
            {name:'三方店铺',value:'true'}
        ],
        shop_type_list_default:[
          {shop_type_name:'全部',shop_type_id:''}
          ],
        shop_type_list:[],
        changeStatus: true,
        activeName: 'first',
        total_count: 0,
        detailDialog: false,
        pcDialogVisible: false,
        dialogTitle: '',
        select_tags_value: '',
        loading: false,
        params: {
          page: 1,
          pageSize: 20,
          name: '',
          mobile: '',
          is_valid: '',
          is_third: '',
          province: '',
          city: '',
          area: '',
          telephone:'',
        },
        form: {
          distributor_id: null,
          mobile: '',
          address: '',
          name: '',
          is_valid: 'true',
          regions_id: [],
          regions: [],
          shop_id: 0,
          contact: ''
        },
        list: [],
        regions: district,
        rowdata: {},
        downDistributorVal: false,
        distributor_id: [],
        categoryList_len:0,
        tag: {
          dialog: false,
          editItem: [],
          list: [],
          form: {
            tag_ids: [],
            distributor_id: []
          },
          currentTags: [],
          tags: []
        },
        chooseCat:[],
        office_area: [],
        checkAll:false,  //全选的v-model值
        new_office_area:[],

      }
    },
    components: { shopDecoration, pcDecoration },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 批量关闭店铺
      mulitClose () {
        if (this.distributor_id.length) {
          let query = {
            "distributor_id": this.distributor_id,
            "is_valid": 'false'
          }
          console.log(query)
          mulitOpenClose(query).then(res => {
            this.$message({
              type: 'success',
              message: '店铺批量关闭完成',
            })
            this.getList()
          })
        } else {
          this.$message({
            type: 'error',
            message: '请选择至少一个店铺!'
          })
        }
      },
      // 批量开启店铺
      mulitOpen () {
        if (this.distributor_id.length) {
          let query = {
            "distributor_id": this.distributor_id,
            "is_valid": 'true'
          }
          console.log(query)
          mulitOpenClose(query).then(res => {
            this.$message({
              type: 'success',
              message: '店铺批量开启完成',
            })
            this.getList()
          })
        } else {
          this.$message({
            type: 'error',
            message: '请选择至少一个店铺!'
          })
        }
      },
      getDistributorNetStatus(distributor_id) {
        let query = {
          "distributor_id": distributor_id
        }
        console.log(query)
        getShengyibaoNetStatus(query).then(response=>{
          this.$message({
            type: 'success',
            message: '医保网络连接正常，请勿频繁访问~'
          })
        })
      },
      CorrectionNPStore(data) {
        var query = {
          "ink_id": data.number
        }
        correctionStore(query).then(response => {
          this.$message({
            type: 'success',
            message: '校正开始，请稍后查看...'
          })
        }).catch(error => {
          this.$message({
            type: 'error',
            message: 'NP库存校正失败'
          })
        })
      },
      updateScope(data) {
        var query = {
          "inca_id": data.number
        }
        updateScope(query).then(response => {
          this.$message({
            type: 'success',
            message: '电子围栏更新成功'
          })
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '电子围栏更新失败'
          })
        })
      },
      exportDistributorInfo(){
        // 导出数据
        exportDistributorInfo(this.params).then(response => {
            //console.log(response.data)
            if(response.data) {
                var a = document.createElement('a')
                a.href = response.data.url
                a.download = response.data.filename
                a.click()
            }
        })
      },
      showQR(row){
        // this.rowdata = row
        // this.downCouponVal = true
        let params = {distributor_id:row.distributor_id}

        getQRcode(params).then(response => {
          var a = document.createElement('a')
          var temp = '微商城'
          a.href = response.data.data.qrcode_url
          if (response.data.data.tempname) {
            var temp = response.data.data.tempname
          }
          a.download = temp + row.title + '.png'
          a.click()
        })
      },
      // getOfficeArea(){
      //   getOfficeArea({'select':1}).then(response => {
      //     this.params.page = 1;
      //     this.office_area=response.data.data.list;
      //   })
      // },
        // 新二级区域
        getnewDataAreaManage(){
            getAreaManageList({'format_flag':true}).then(response => {
               this.params.page = 1;
               this.new_office_area =response.data.data;
            })
        },
       /************ 根据大区搜索 ***********/
       /*
      handleOfficeChange:function (val){
        this.office_area_name = val
        var now_office_area_id = ''
        office_area.map(function(value,index,array){
          if(value.name === val){
            now_office_area_id = value.area_id
          }
        })
        this.office_area_id = now_office_area_id
        this.params.office_area_id = this.office_area_id
        this.getList()
      },
      */
        handleOfficeChange:function (val){

            console.log(val);
            //分离出区域id 和区域父id
            var now_office_area_pid = val[0]
            this.selected_office_area_id[0] = now_office_area_pid;
            if(val.length > 1){
                var now_office_area_id = val[1]
                this.selected_office_area_id[1] = now_office_area_id
            }else{
                var now_office_area_id = 0
            }
            // console.log(now_office_area_id)
            // console.log(now_office_area_pid)
            this.office_area_id = now_office_area_id
            this.office_area_pid = now_office_area_pid
            this.params.office_area_id = now_office_area_id
            this.params.office_area_pid = now_office_area_pid
            this.getList()
        },

      /**********END**************/
      dialogShow (id, type) {
        this.current = id
        type === 'pc' ? this.pcDialogVisible = true : this.dialogVisible = true
      },
      closeDialog () {
        this.dialogVisible = false
        this.pcDialogVisible = false
      },
      isValidSelectHandle () {
        this.params.page = 1
        this.getList()
      },
       plantSelectHandle(){
           this.params.page = 1
           this.getList()
       },
      shopTypesSelectHandle () {
        this.params.page = 1
        this.getList()
      },
      getDataId(e){
        var id = e.target.dataset.id;
        if(e.target.checked == false){
          var index = this.chooseCat.indexOf(id);
          this.chooseCat.splice(index,1);
        }
        else{
          this.chooseCat.push(id);
        }
        console.log(id,this.chooseCat)
      },
      //全选 反选
      clickCheckAll:function () {
        var _this = this;
        _this.chooseCat = [];
        _this.checkAll = !_this.checkAll;   //取反
        for (var i=0;i<_this.categoryList.length;i++){  //循环所有checkbox,添加选中状态
          var checkedData = _this.categoryList[i];
          checkedData.isChecked = _this.checkAll;
          _this.chooseCat.push(_this.categoryList[i]['category_id']);
        }
        if (_this.checkAll == false){_this.chooseCat = [];}
        console.log(_this.checkAll,_this.chooseCat)
      },
      numberSearch (e) {
        this.params.page = 1
        this.getList()
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getList()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getList()
      },
      dialogOpen (detail = null) {
        this.$router.push({path: this.matchHidePage('editor')})
      },
      getList () {
        this.loading = true
        // if (this.params.numbers) {
        //   this.params.number = this.params.numbers.split("\n");
        // }
        // console.log(this.params)
        getDistributorList(this.params).then(response => {
          if (response.data.data.list) {
            this.list = response.data.data.list
            this.total_count = response.data.data.total_count
          }
          this.loading = false
        })
      },
      getCategory() {
        getCategory(this.CategoryListparams).then(response => {
          var res = response.data.data;
          this.categoryList = response.data.data ? response.data.data : [];
          this.categoryList_len=response.data.data ? response.data.data.length: 0;
          this.loadingCategoryF = true
          this.spaceInput = false
          //getCategory
        })
      },

      handleCancel () {
        this.editCategroyVisible=false
      },
      // 编辑分类弹出
      editCategoryAction () {
        if (this.distributor_id.length) {
          // console.log('xxxxxx')
          // console.log(this.distributor_id)
          // this.tag.form.distributor_id = this.distributor_id
        } else {
          this.$message({
            type: 'error',
            message: '请选择至少一个店铺!'
          })
          return false;
        }
        this.editTitleCategroy = '店铺分类'
        this.editCategroyVisible = true
      },

      submitCategoryAction () { // 提交店铺分类

        this.submitLoading = true
        if(this.chooseCat.length > 0){
          console.log(this.distributor_id)
          let params = {distributor_ids:this.distributor_id,categorys:this.chooseCat}
          editDistributorItemsCategory(params).then(response => {
            this.editCategroyVisible = false
            this.submitLoading = false
            this.$message({
              type: 'success',
              message: '保存成功'
            })
          })
        }else{
          this.$message({
            type: 'error',
            message: '请选择至少一个商品分类'
          })
        }
        //

      },

      downDistributorCode (row, template_name) {
        let params = {distributor_id: row.distributor_id}
        if (template_name) {
          params.template_name = template_name
        }
        getWxaDristributorCodeStream(params).then(response => {
          var a = document.createElement('a')
          var temp = '微商城'
          a.href = response.data.data.base64Image
          if (response.data.data.tempname) {
            var temp = response.data.data.tempname
          }
          a.download = temp + row.name + '.png'
          a.click()
        })
      },
      RegionChangeSearch (value) {
        var vals = getCascaderObj(value, this.regions)
        if (vals.length == 1) {
          this.params.province = vals[0].label
          this.params.city = ''
          this.params.area = ''
        } else if (vals.length == 2) {
          this.params.province = vals[0].label
          this.params.city = vals[1].label
          this.params.area = ''
        } else if (vals.length == 3) {
          this.params.province = vals[0].label
          this.params.city = vals[1].label
          this.params.area = vals[2].label
        }
        this.params.page = 1
        this.getList()
      },
      TagChangeAction(value) {
        this.params.tag_id = value
        this.params.page = 1
        this.getList()
      },
      downDistributor (row) {
        this.rowdata = row
        this.downDistributorVal = true
      },
      defaultSwitchChange (row) {
        var params = {
          'distributor_id': row.distributor_id
        }
        setDefaultDistributor(params).then(response => {
          if (response.data.data.status) {
            for (var i = this.list.length - 1; i >= 0; i--) {
              if (this.list[i].distributor_id != row.distributor_id) {
                this.list[i].is_default = false
              }
            }
          }
        })
      },
      switchChangeAuditGoods(index, row) {
        var params = {
          'distributor_id': row.distributor_id,
          'is_audit_goods': row.is_audit_goods
        }
        saveDistributor(params).then(response => {
          this.detailDialog = false
          this.getList()
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        })
      },
      switchChangeAutoSyncGoods(index, row) {
        var params = {
          'distributor_id': row.distributor_id,
          'auto_sync_goods': row.auto_sync_goods
        }
        saveDistributor(params).then(response => {
          this.detailDialog = false
          this.getList()
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        })
      },
      switchChangeExpress(index, row) {
          var params = {
              'distributor_id': row.distributor_id,
              'isExpress': row.isExpress
          }
          saveIsExpress(params).then(response => {
              this.detailDialog = false
              this.getList()
              this.$message({
                  type: 'success',
                  message: '保存成功'
              })
          })
      },
      switchChange (index, row) {
        var params = {
          'distributor_id': row.distributor_id,
          'is_ziti': row.is_ziti
        }
        saveDistributor(params).then(response => {
          this.detailDialog = false
          this.getList()
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        })
      },
      handleSelectionChange (val) {
        let distributor_id = []
        for (let i in val) {
          distributor_id.push(val[i].distributor_id)
        }
        this.distributor_id = distributor_id
      },
      getAllTagList () {
        let params = {
          page: 1,
          pageSize: 500
        }
        getTagList(params).then(response => {
          this.tag.list = response.data.data.list
        })
      },
      handleCancelLabelsDialog() {
        this.tag.dialog = false
      },
      tagUpdate(row) {
        this.tag.editItem = [row.itemName]
        this.tag.currentTags = row.tagList || []
        this.tag.form.distributor_id = row.distributor_id
        this.showTags()
      },
      addDistributorTag() {
        this.tag.currentTags = []
        if (this.distributor_id.length) {
          this.showTags()
          this.tag.form.distributor_id = this.distributor_id
        } else {
          this.$message({
            type: 'error',
            message: '请选择至少一个店铺!'
          })
        }
      },
      showTags() {
        // this.tag.tags = [...this.tag.list]
        this.tag.tags = []
        this.tag.list.forEach((item, index) => {
          let isInArr = this.tag.currentTags.findIndex((n) => n.tag_id == item.tag_id)
          if (isInArr == -1) this.tag.tags.push(item)
        })
        this.tag.dialog = true
      },
      tagRemove(index) {
        this.tag.tags.unshift(this.tag.currentTags[index])
        this.tag.currentTags.splice(index, 1)
      },
      tagAdd(item, index) {
        let isInArr = this.tag.currentTags.findIndex(n => n.tag_id == item.tag_id)
        if (isInArr == -1) {
          this.tag.currentTags.push(item)
          this.tag.tags.splice(index, 1)
        }
      },
      submitItemTag() {
        this.tag.form.tag_ids = []
        this.tag.currentTags.forEach(item => {
          this.tag.form.tag_ids.push(item.tag_id)
        })
        /**
        if (this.tag.form.tag_ids.length <= 0) {
          this.$message({
            type: 'error',
            message: '请选择店铺标签'
          })
          return false
        }
        */
        this.tag.dialog = false
        distributorRelTags(this.tag.form).then(res => {
          if (res.data.data.status) {
            this.$message({
              type: 'success',
              message: '打标签完成'
            })
          }
        })
      },
      tagSearchUserChange() {
        this.currentPage = 1
        this.getParams()
        this.getItemsList(this.params)
        this.loading = false
      },
      getShopTypesData() {
        getShopTypes().then(res => {
          this.shop_type_list = res.data.data.list
        })
      },
    },
    mounted () {
      if (store.getters.login_type === 'distributor') {
        this.is_distributor = true
      }
      this.getList()
      this.getAllTagList()
      this.getCategory()
      this.getShopTypesData()
      this.getnewDataAreaManage()
    }

  }
</script>

<style lang="scss" scoped>
  .tag-users {
    padding-bottom: 10px;
    line-height: 1.2;
    .icon-user-circle1 {
        margin-right: 10px;
        font-size: 24px;
        color: #ccc;
    }
  }
  .selected-tags {
    padding-top: 15px;
    margin-bottom: 15px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    .label {
        margin-bottom: 15px;
    }
    .el-tag {
        margin-right: 10px;
        margin-bottom: 15px;
    }
  }
  .tag-item {
    cursor: pointer;
    color: #666;
    border-color: #dadadd;
    margin-right: 10px;
    margin-top: 10px;
  }
  .shengyibao_status {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// distributor.vue?895d6af2